import * as React from 'react';
import {
  List, Datagrid, Edit, Create, Show, SimpleShowLayout,
  TextField, BooleanField, DateField,
  SimpleForm, TextInput, NumberInput, BooleanInput,
  TopToolbar, Button, EditButton, ShowButton
} from 'react-admin';
import { useRedirect } from 'react-admin';
import ArrowBack from '@material-ui/icons/ArrowBack';

const useTxtData = {
  page: { tableName: '地址管理' },
  table: {
    id: 'ID',
    UserId: '用户ID',
    Name: '姓名',
    Mobile: '手机号',
    Province: '省份',
    City: '城市',
    Area: '区县',
    Addr: '详细地址',
    JiFen: '积分',
    UpTime: '更新时间'
  }
};

const RowAction = (props) => {
  return null;

  return (
    <div style={{ textAlign: 'right' }}>
      <EditButton {...props} /><br />
      <ShowButton {...props} />
    </div>
  );
};

export const LFAddressList = (props) => (
  <List {...props} title={useTxtData.page.tableName + '列表'} sort={{ field: 'id', order: 'DESC' }}
    exporter={false}
    bulkActionButtons={false}
  >
    <Datagrid>
      {/* <TextField label={useTxtData.table.id} source="id" /> */}
      <TextField label={useTxtData.table.UserId} source="UserId" />
      <TextField label={useTxtData.table.Name} source="Name" />
      <TextField label={useTxtData.table.Mobile} source="Mobile" />
      <TextField label={useTxtData.table.Province} source="Province" />
      <TextField label={useTxtData.table.City} source="City" />
      <TextField label={useTxtData.table.Area} source="Area" />
      <TextField label={useTxtData.table.Addr} source="Addr" />
      <TextField label={useTxtData.table.JiFen} source="JiFen" />
      <DateField label={useTxtData.table.UpTime} source="UpTime" showTime />
      <RowAction />
    </Datagrid>
  </List>
);

export const LFAddressShow = (props) => {
  const redirect = useRedirect();
  return (
    <Show title={'查看' + useTxtData.page.tableName} {...props} actions={
      <TopToolbar>
        <Button label="返回列表" onClick={() => redirect('/Admin/LFAddress')} variant="text">
          <ArrowBack />
        </Button>
      </TopToolbar>
    }>
      <SimpleShowLayout>
        <TextField label={useTxtData.table.id} source="id" />
        <TextField label={useTxtData.table.UserId} source="UserId" />
        <TextField label={useTxtData.table.Name} source="Name" />
        <TextField label={useTxtData.table.Mobile} source="Mobile" />
        <TextField label={useTxtData.table.Province} source="Province" />
        <TextField label={useTxtData.table.City} source="City" />
        <TextField label={useTxtData.table.Area} source="Area" />
        <TextField label={useTxtData.table.Addr} source="Addr" />
        <TextField label={useTxtData.table.JiFen} source="JiFen" />
        <DateField label={useTxtData.table.UpTime} source="UpTime" />
      </SimpleShowLayout>
    </Show>
  );
};

export const LFAddressEdit = (props) => (
  <Edit title={'编辑' + useTxtData.page.tableName} {...props}>
    <SimpleForm>
      <TextInput label={useTxtData.table.Name} source="Name" />
      <TextInput label={useTxtData.table.Mobile} source="Mobile" />
      <TextInput label={useTxtData.table.Province} source="Province" />
      <TextInput label={useTxtData.table.City} source="City" />
      <TextInput label={useTxtData.table.Area} source="Area" />
      <TextInput label={useTxtData.table.Addr} source="Addr" />
      <NumberInput label={useTxtData.table.JiFen} source="JiFen" />
    </SimpleForm>
  </Edit>
);

export const LFAddressCreate = (props) => (
  <Create title={'新增' + useTxtData.page.tableName} {...props}>
    <SimpleForm>
      <NumberInput label={useTxtData.table.UserId} source="UserId" defaultValue={0} />
      <TextInput label={useTxtData.table.Name} source="Name" />
      <TextInput label={useTxtData.table.Mobile} source="Mobile" />
      <TextInput label={useTxtData.table.Province} source="Province" />
      <TextInput label={useTxtData.table.City} source="City" />
      <TextInput label={useTxtData.table.Area} source="Area" />
      <TextInput label={useTxtData.table.Addr} source="Addr" />
      <NumberInput label={useTxtData.table.JiFen} source="JiFen" defaultValue={0} />
    </SimpleForm>
  </Create>
);